import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import {
  getPaymentByID,
  getPaymentInstallment,
  getPaymentInstallmentSelectedPrice,
  isPaymentInstallmentOverdue,
  isPaymentInstallmentInBasket
} from "state/school_money/selectors";
import {
  setPaymentInstallmentSelectedPrice,
  removePaymentInstallmentFromBasket
} from "state/school_money/actions";

import Currency from "components/Currency";
import Date from "components/Date";
import MoneyInput from "components/MoneyInput";
import BasketModificationModal from "components/school_money/BasketModificationModal";
import PaymentBasketButton from "components/school_money/payments/PaymentBasketButton";

import "./PaymentInstallment.css";

class PaymentInstallment extends React.Component {
  
  state = {
    isBasketModificationModalOpen: false,
    isInputValid: true
  }
  
  onReadOnlyClick = () => {
    this.setState({ isBasketModificationModalOpen: true });
  }
  
  closeBasketModificationModal = result => {
    if (result) {
      this.props.removeFromBasket();
    }
    this.setState({ isBasketModificationModalOpen: false });
  }
  
  onSelectedPriceChange = amount => {
    this.props.setSelectedPrice(amount);
  }
  
  validateInput = amount => {
    const { isVoluntary } = this.props.payment;
    const maxPrice = isVoluntary ? Infinity : this.props.installment.outstandingPrice;
    return amount > 0 && amount <= maxPrice;
  }
  
  onInputValidityChange = isInputValid => {
    this.setState({ isInputValid });
  }
  
  render() {
    
    const { payment, paymentID, installment, installmentNumber, selectedPrice, isInBasket, isOverdue, showAddRemoveButtons } = this.props;
    const { isPartial, isVoluntary } = payment.toObject();
    const { dueDate, outstandingPrice } = installment.toObject();
    const { isInputValid } = this.state;
    
    const classNames = [ "payment-installment" ];
    if (isInBasket) {
      classNames.push("payment-installment--in-basket");
    }
    if (isOverdue) {
      classNames.push("payment-installment--overdue");
    }
    if (!showAddRemoveButtons) {
      classNames.push("payment-installment--no-buttons");
    }
    if (!isInputValid) {
      classNames.push("payment-installment--invalid");
    }
    
    return (
      <tr className={classNames.join(" ")}>
        <BasketModificationModal
          isOpen={this.state.isBasketModificationModalOpen}
          onClose={this.closeBasketModificationModal}
          itemName="installment"
        />
        <td className="payment-installment__price">
          {
            isPartial || isVoluntary ?
            <MoneyInput
              className="payment-installment__price-input"
              initialAmount={selectedPrice}
              defaultAmount={outstandingPrice}
              onChange={this.onSelectedPriceChange}
              validateInput={this.validateInput}
              onValidityChange={this.onInputValidityChange}
              readOnly={isInBasket}
              onReadOnlyClick={this.onReadOnlyClick}
            /> :
            <Currency className="payment-installment__price-amount" amount={selectedPrice} />
          }
        </td>
        <td className="payment-installment__due-date">
          <Date date={dueDate} />
        </td>
        {
          showAddRemoveButtons ?
          <td className="payment-installment__button">
            <PaymentBasketButton
              cssBlockName="payment-installment"
              paymentID={paymentID}
              installmentNumber={installmentNumber}
              canAddToBasket={isInputValid}
            />
          </td> :
          null
        }
      </tr>
    )
    
  }
  
}

export default connect(
  (state, { paymentID, installmentNumber }) => ({
    payment: getPaymentByID(state, paymentID),
    installment: getPaymentInstallment(state, paymentID, installmentNumber),
    selectedPrice: getPaymentInstallmentSelectedPrice(state, paymentID, installmentNumber),
    isOverdue: isPaymentInstallmentOverdue(state, paymentID, installmentNumber),
    isInBasket: isPaymentInstallmentInBasket(state, paymentID, installmentNumber)
  }),
  (dispatch, { paymentID, installmentNumber }) => bindActionCreators({
    setSelectedPrice: inputPrice => setPaymentInstallmentSelectedPrice(paymentID, installmentNumber, inputPrice),
    removeFromBasket: () => removePaymentInstallmentFromBasket(paymentID, installmentNumber)
  }, dispatch)
)(PaymentInstallment);



// WEBPACK FOOTER //
// ./src/components/school_money/payments/PaymentInstallment.js